import React from 'react';
import { PaymentIcon } from 'react-svg-credit-card-payment-icons';

const PaymentMethodCard = ({ 
  cardType = '', 
  lastFour = '', 
  isPromptOnly = false,
  isDescriptionOnly = false,
  isActive = false,
  onClick = () => {}
}) => {
  const cardStyle = {
    borderRadius: '24px',
  border: '2px solid transparent', // Must be transparent
  backgroundImage: `
    linear-gradient(144deg, #1D151D 42.84%, #4E2D33 179.39%), 
    linear-gradient(317deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 38.67%, #6B3A8F 78.77%, #5D2A79 115.46%)
  `,
  backgroundOrigin: 'border-box',
  backgroundClip: 'padding-box, border-box',
    boxShadow: '5px 2px 20px 0px rgba(63, 39, 102, 0.15)',
    backdropFilter: 'blur(2.5px)',
    padding: '30px',
    marginBottom: '24px'
  };

  const contentStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  const infoStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  };

  const typeStyle = {
    fontSize: '18px',
    fontWeight: '300',
    color: 'white'
  }

  const numberStyle = {
    fontSize: '14px',
    color: '#BBA4AB'
  };

  const badgeStyle = {
    backgroundColor: '#1d151d', 
    color: 'white',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    marginRight: '24px'
  };

  const manageStyle = {
    background: 'none',
    border: '1px solid #A29EDA',
    color: '#A29EDA',
    cursor: 'pointer',
    fontSize: '14px',
    padding: '4px 12px',
    borderRadius: '16px',
    transition: 'all 0.2s ease'
  };

  return (
    <div style={cardStyle}>
      <div style={contentStyle}>
        <div style={infoStyle}>
          {isDescriptionOnly ? (
            <div style={numberStyle}>No active subscription. Renew here 👉</div>
          ) : (
            isPromptOnly ? (
              <div style={numberStyle}>
                Choose a subscription plan below! 👇
              </div>
            ) : (
                <>
              <div style={{paddingRight: '2px'}}>
                {<PaymentIcon type={cardType} format="flatRounded"/>}
              </div>
              <div style={numberStyle}>
                Card ending in {lastFour}
              </div>
              </>
            )
          )}
          {isActive && <span style={badgeStyle}>Default</span>}
        </div>
        {!isPromptOnly &&
          <button style={manageStyle} onClick={onClick} data-cy="settingsBillingManage-button">Manage</button>
        }
      </div>
    </div>
  );
};

export default PaymentMethodCard;